import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const Link = makeShortcode("Link");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const PropsTableRefRow = makeShortcode("PropsTableRefRow");
const PropsTablePassthroughPropsRow = makeShortcode("PropsTablePassthroughPropsRow");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`TextInput is a form component to add default styling to the native text input.`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` Don't forget to set `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to make the TextInput accessible to screen reader users.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput aria-label="Zipcode" name="zipcode" placeholder="Zipcode" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`With icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput
    leadingVisual={SearchIcon}
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Zip"
    autoComplete="postal-code"
  />

  <TextInput
    trailingVisual={SearchIcon}
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Zip"
    autoComplete="postal-code"
  />
</>
`}</code></pre>
    <h3>{`With text visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput leadingVisual="$" aria-label="Cost of the thing" name="cost" placeholder="23.45" />

  <TextInput sx={{width: '150px'}} trailingVisual="minutes" aria-label="Time in minutes" name="time" placeholder="25" />
</>
`}</code></pre>
    <h3>{`With visuals and loading indicators`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const WithIconAndLoadingIndicator = () => {
  const [loading, setLoading] = React.useState(true)

  const toggleLoadingState = () => {
    setLoading(!loading)
  }

  return (
    <>
      <Box mb={6}>
        <button type="button" onClick={toggleLoadingState}>
          Toggle loading state {loading ? 'off' : 'on'}
        </button>
      </Box>

      <Text fontSize={3} mb={1} display="block">
        No visual
      </Text>
      <Box mb={3}>
        <TextInput loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Leading visual
      </Text>
      <Box mb={3}>
        <TextInput leadingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Trailing visual
      </Text>
      <Box mb={3}>
        <TextInput trailingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={1} display="block">
        Both visuals
      </Text>
      <Box mb={3}>
        <TextInput leadingVisual={SearchIcon} trailingVisual={SearchIcon} loading={loading} />
      </Box>

      <Text fontSize={3} mb={2} display="block">
        Both visuals, position overriden
      </Text>
      <Box mb={3}>
        <TextInput loaderPosition="trailing" leadingVisual={SearchIcon} trailingVisual={SearchIcon} loading={loading} />
      </Box>
    </>
  )
}

render(<WithIconAndLoadingIndicator />)
`}</code></pre>
    <h3>{`With trailing action`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Icon action</FormControl.Label>
  <TextInput
    trailingAction={
      <TextInput.Action
        onClick={() => {
          alert('clear input')
        }}
        icon={XIcon}
        aria-label="Clear input"
        sx={{color: 'fg.subtle'}}
      />
    }
  />
</FormControl>
`}</code></pre>
    <h3>{`With error and warning states`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <TextInput
    validationStatus="error"
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Error"
    autoComplete="postal-code"
  />

  <TextInput
    validationStatus="warning"
    aria-label="Zipcode"
    name="zipcode"
    placeholder="Warning"
    autoComplete="postal-code"
  />
</>
`}</code></pre>
    <h3>{`Block text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput block aria-label="Zipcode" name="zipcode" placeholder="560076" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`Contrast text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput contrast aria-label="Zipcode" name="zipcode" placeholder="Find user" autoComplete="postal-code" />
`}</code></pre>
    <h3>{`Monospace text input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput
  monospace
  aria-label="personal access token"
  name="pat"
  leadingVisual={CheckIcon}
  placeholder="github_pat_abcdefg123456789"
/>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`TextInput`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" description="Allows input to be accessible." mdxType="PropsTableRow" />
  <PropsTableRow name="block" type="boolean" defaultValue="false" description="Creates a full-width input element" mdxType="PropsTableRow" />
  <PropsTableRow name="contrast" type="boolean" defaultValue="false" description="Changes background color to a higher contrast color" mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="'small' | 'medium' | 'large'" description="Creates a smaller or larger input than the default." mdxType="PropsTableRow" />
  <PropsTableRow name="loading" type="boolean" description="Whether to show a loading indicator in the input" mdxType="PropsTableRow" />
  <PropsTableRow name="loaderPosition" type="'auto' | 'leading' | 'trailing'" description={<>
        <div>Which position to render the loading indicator</div>
        <ul>
          <li>
            'auto' (default): at the end of the input, unless a `leadingVisual` is passed. Then, it will render at the
            beginning
          </li>
          <li>'leading': at the beginning of the input</li>
          <li>'trailing': at the end of the input</li>
        </ul>
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="leadingVisual" type={<>string | React.ComponentType</>} description="Visual positioned on the left edge inside the input" mdxType="PropsTableRow" />
  <PropsTableRow name="monospace" type="boolean" defaultValue="false" description="Shows input in monospace font" mdxType="PropsTableRow" />
  <PropsTableRow name="trailingVisual" type={<>string | React.ComponentType</>} description="Visual positioned on the right edge inside the input" mdxType="PropsTableRow" />
  <PropsTableRow name="trailingAction" type="React.ReactElement<HTMLProps<HTMLButtonElement>>" description="A visual that renders inside the input after the typing area" mdxType="PropsTableRow" />
  <PropsTableRow name="validationStatus" type="'error' | 'success' | 'warning'" description="Style the input to match the status" mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="'small' | 'medium' | 'large'" description="(Use size) Creates a smaller or larger input than the default." deprecated mdxType="PropsTableRow" />
  <PropsTableRow name="width" type={<>
        string | number | <Link href="https://styled-system.com/guides/array-props" mdxType="Link">Array&lt;string | number&gt;</Link>
      </>} description="(Use sx prop) Set the width of the input" deprecated mdxType="PropsTableRow" />
  <PropsTableRow name="maxWidth" type={<>
        string | number | <Link href="https://styled-system.com/guides/array-props" mdxType="Link">Array&lt;string | number&gt;</Link>
      </>} description="(Use sx prop) Set the maximum width of the input" deprecated mdxType="PropsTableRow" />
  <PropsTableRow name="minWidth" type={<>
        string | number | <Link href="https://styled-system.com/guides/array-props" mdxType="Link">Array&lt;string | number&gt;</Link>
      </>} description="(Use sx prop) Set the minimum width of the input" deprecated mdxType="PropsTableRow" />
  <PropsTableRow name="icon" type="React.ComponentType" description="(Use leadingVisual or trailingVisual) An Octicon React component. To be used inside of input. Positioned on the left edge." deprecated mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTableRefRow elementType="input" refType="HTMLInputElement" description="A ref to the input element rendered by this component. Note: this is not the outermost element rendered by TextInput. There is also a div wrapper for which a ref is not accepted." mdxType="PropsTableRefRow" />
  <PropsTablePassthroughPropsRow elementName="input" passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes" mdxType="Link">MDN</Link>} mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h3>{`TextInput.Action`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" description="Text that appears in a tooltip. If an icon is passed, this is also used as the label used by assistive technologies." mdxType="PropsTableRow" />
  <PropsTableRow name="icon" type="React.FunctionComponent" description="The icon to render inside the button" mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="'default' | 'primary' | 'invisible' | 'danger'" description="(Deprecated so that only the 'invisible' variant is used) Determine's the styles on a button" deprecated mdxType="PropsTableRow" />
  <PropsTableBasePropRows elementType="button" refType="HTMLButtonElement" passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attributes" mdxType="Link">MDN</Link>} mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      